module.exports = __webpack_public_path__ + "static/img/1.3e5155d6.jpg";